import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Popover, Button, Select } from 'antd';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSort, faTimes } from '@fortawesome/pro-regular-svg-icons';
import style from './index.scss';

import startCase from 'lodash/startCase';
import { getKeys } from '../utils';
import { isEmpty } from 'lodash';
import { buildSortPayload } from './sortUtils';

const { Option } = Select;

function SortComponent(props) {
  const [visible, setVisible] = useState(false);
  const [sortableKeys, setSortableKeys] = useState([]);
  const [selectedSort, setSelectedSort] = useState({});
  const { widgetItemOperations, filters } = props;
  const [disableBtn, setDisableBtn] = useState(true);

  useEffect(() => {
    getSortableKeys();
  }, [widgetItemOperations]);

  const showPopUp = () => {
    setVisible(true);
  };

  const hidePopUp = () => {
    setVisible(false);
  };

  const handleVisibleChange = (visibility) => {
    setVisible(visibility);
  };

  const getSortableKeys = () => {
    if (widgetItemOperations) {
      const sortKeys = getKeys(widgetItemOperations, 'isSortable');
      setSortableKeys(sortKeys);
    }
  };

  const handleChange = (selectedOption, label) => {
    const obj = { columnName: label, operator: selectedOption.value };
    setSelectedSort(obj);
  };

  const sortHandler = () => {
    props.applyFilterHandler(buildSortPayload(selectedSort));
    hidePopUp();
  };

  const renderSortItem = (item, selectedSortItem) => {
    let itemLabel = startCase(item.itemName);

    let options = [
      { label: 'Highest to Lowest', value: 'DESC' },
      { label: 'Lowest to Highest', value: 'ASC' }
    ];
    if (item.itemName == 'alertDate') {
      options = [
        { label: 'Newest to Oldest', value: 'DESC' },
        { label: 'Oldest to Newest', value: 'ASC' }
      ];
    }
    const sortByOption = { label: 'Sort by', value: '' };
    const optionsArray = [sortByOption, ...options];
    const defaultKeyValue = { value: '' };
    let selectedValue = defaultKeyValue;

    if (selectedSortItem && selectedSortItem.columnName == item.itemName) {
      selectedValue = { value: selectedSortItem.operator };
    }

    return (
      <div className={style.item} key={item.itemName}>
        <label>{itemLabel}</label>
        {options && (
          <Select
            defaultValue={defaultKeyValue}
            labelInValue
            onChange={(value) => handleChange(value, item?.itemName)}
            options={optionsArray}
            value={selectedValue}
          />
        )}
      </div>
    );
  };

  useEffect(() => {
    if (isEmpty(selectedSort)) {
      setDisableBtn(true);
    } else {
      setDisableBtn(false);
    }
  }, [selectedSort]);

  const clearSortHandler = () => {
    setSelectedSort({});
    if (!isEmpty(filters?.sort)) {
      props.applyFilterHandler({
        sort: null
      });
      hidePopUp();
    }
  };

  const popoverContent = () => {
    return (
      <div className={style.popover}>
        <div className={style.popover_head}>
          <h6>Sort</h6>
          <div id="faTimesIcon" onClick={hidePopUp}>
            <FontAwesomeIcon icon={faTimes} />
          </div>
        </div>
        <div className={style.popover_content}>
          <div className={style.popover_content__card}>
            <div className={style.popover_content__card_header}>
              <span className={style.popover_content__card_header__label}>
                Field
              </span>
              <span className={style.popover_content__card_header__label}>
                Sort By
              </span>
            </div>
            <div className={style.popover_content__card_body}>
              {sortableKeys.map((item) => renderSortItem(item, selectedSort))}
            </div>
          </div>
        </div>
        <div className={style.popover_footer}>
          <Button onClick={clearSortHandler} disabled={disableBtn}>
            Clear
          </Button>
          <Button onClick={sortHandler} type="primary" disabled={disableBtn}>
            Apply
          </Button>
        </div>
      </div>
    );
  };

  return (
    <div className={style.wrapper}>
      <p className={style.iconLabel}>Sort</p>
      <Popover
        content={popoverContent}
        visible={visible}
        trigger="click"
        onVisibleChange={handleVisibleChange}
        placement="bottomLeft">
        <div id="faSortIcon" className={style.iconWrapper} onClick={showPopUp}>
          <FontAwesomeIcon icon={faSort} />
        </div>
      </Popover>
    </div>
  );
}

SortComponent.propTypes = {
  widgetItemOperations: PropTypes.object,
  applyFilterHandler: PropTypes.func.isRequired,
  filters: PropTypes.object
};

export default SortComponent;
